import PanelPeriodControl from "connected-components/dashboard/components/panel-period-control"
import { useAssetViewData } from "../hooks/use-asset-view-data"

interface AssetViewPanelPeriodControlProps {
  isPerformance?: boolean
}

export default function AssetViewPanelPeriodControl({ isPerformance = true }: AssetViewPanelPeriodControlProps) {
  const { dateOverride, setDateOverride, clearDateOverride, earliestDate, latestDate, startDate, endDate, isDateOverrideActive } = useAssetViewData()

  return (
    <PanelPeriodControl
      dates={{ earliestDate, latestDate, startDate, endDate }}
      dateOverride={dateOverride}
      isDateOverrideActive={isDateOverrideActive}
      setDateOverride={setDateOverride}
      clearDateOverride={clearDateOverride}
      isPerformance={isPerformance}
    />
  )
}
